module.exports = __webpack_public_path__ + "static/library5-d3d70727f2d0290fb4e074fcc29e566a.png";